import { render, staticRenderFns } from "./StockArchiveTable.vue?vue&type=template&id=1cdd6cbc&scoped=true&"
import script from "./StockArchiveTable.vue?vue&type=script&lang=ts&"
export * from "./StockArchiveTable.vue?vue&type=script&lang=ts&"
import style0 from "./StockArchiveTable.vue?vue&type=style&index=0&id=1cdd6cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd6cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VSnackbar,VTextField})
